var whiteGenericFlag = "\uD83C\uDFF3";
var rootUnicodeFlagsIndex = 127397;
/**
 * Given a country code, returns the emoji representation for that entity.
 *
 * Note: on certain emoji implementations including Windows systems, instead
 * of a flag, just the strings of the country code may be returned. See:
 * https://answers.microsoft.com/en-us/windows/forum/all/flag-emoji/85b163bc-786a-4918-9042-763ccf4b6c05
 *
 * @param countryCode - The ISO 3166-1 compliant code which
 * denotes a country. If omitted, a generic white flag to denote an unknown
 * country shall be returned.
 *
 * @returns The emoji representation of the country.
 */

var getFlagEmoji = function getFlagEmoji(countryCode) {
  if (!countryCode) {
    return whiteGenericFlag;
  }

  return countryCode.toUpperCase().replace(/./g, function (_char) {
    return String.fromCodePoint(rootUnicodeFlagsIndex + _char.charCodeAt(0));
  });
};

export { getFlagEmoji };
